// extracted by mini-css-extract-plugin
export var aboveInput = "_lk-0";
export var actionButton = "_lk-5";
export var actionButtonContainer = "_lk-1";
export var actionIcon = "_lk-6";
export var aiInfoContainer = "_lk-2";
export var attachmentWrapper = "_lk-7";
export var bold = "_lk-3";
export var checkIcon = "_lk-8";
export var clickingRecipientBar = "_lk-11";
export var commentThreadSwitch = "_lk-a";
export var draftImage = "_lk-b";
export var draftImageContainer = "_lk-c";
export var draftImages = "_lk-e";
export var editButton = "_lk-g";
export var editor = "_lk-f";
export var editorContainer = "_lk-y";
export var editorErrorTooltipWrapper = "_lk-9";
export var headerDivider = "_lk-h";
export var icon = "_lk-i";
export var info = "_lk-j";
export var internal = "_lk-n";
export var internalDivider = "_lk-k";
export var internalMessage = "_lk-l";
export var messageInputCard = "_lk-m";
export var messageInputForm = "_lk-o";
export var messageInputFormInternal = "_lk-p";
export var options = "_lk-q";
export var publicMessageCustomer = "_lk-s";
export var publicMessageMerchant = "_lk-r";
export var removeImageButton = "_lk-d";
export var replyButtons = "_lk-t";
export var showSignatureButton = "_lk-u";
export var spinner = "_lk-v";
export var verticalButtonDivider = "_lk-4";
export var visibilitySelector = "_lk-w";
export var warning = "_lk-x";
export var wrappingText = "_lk-z";
export var writingInternalNoteTopBorder = "_lk-10";